import React from 'react';
import { X, Check } from 'lucide-react';
export function FilterSection() {
  return <section className="py-24 bg-[#111]" data-id="element-45">
      <div className="container mx-auto px-4" data-id="element-46">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-47">
          {/* Not for you */}
          <div className="bg-[#0a0a0a] p-10 border border-red-900/20" data-id="element-48">
            <h3 className="text-2xl font-['Bebas_Neue'] text-gray-400 mb-8" data-id="element-49">
              NO ES PARA VOS SI:
            </h3>
            <ul className="space-y-6" data-id="element-50">
              {['Buscás comodidad', 'Buscás excusas', 'Buscás motivación pasajera', 'Querés resultados sin esfuerzo'].map((item, i) => <li key={i} className="flex items-center gap-4 text-gray-500" data-id="element-51">
                  <X className="w-5 h-5 text-red-900" data-id="element-52" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Is for you */}
          <div className="bg-[#0a0a0a] p-10 border border-[#C9A84C]/30 relative overflow-hidden" data-id="element-53">
            <div className="absolute top-0 right-0 w-20 h-20 bg-[#C9A84C]/10 blur-xl rounded-full" data-id="element-54" />

            <h3 className="text-2xl font-['Bebas_Neue'] text-[#C9A84C] mb-8" data-id="element-55">
              ES PARA VOS SI:
            </h3>
            <ul className="space-y-6" data-id="element-56">
              {['Querés resultados reales', 'Estás dispuesto a incomodarte', 'Querés disciplina como identidad', 'Estás listo para dejar de mentirte'].map((item, i) => <li key={i} className="flex items-center gap-4 text-white font-medium" data-id="element-57">
                  <Check className="w-5 h-5 text-[#C9A84C]" data-id="element-58" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}